/** @jsxImportSource @emotion/react */
import React from 'react';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import { UDText } from 'ud-ui/components';
import * as S from './styles';

interface IUserInfoProps extends DivProps {
  avatar?: string;
  title?: string;
  subtitle?: string;
}

function UserInfo(props: IUserInfoProps) {
  const { avatar, title, subtitle, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <S.AvatarImage src={avatar ?? USER_DEFAULT_AVATAR} alt="avatar" />
      <S.InfoBlock>
        <S.TitleTruncate variant="body-3">{title}</S.TitleTruncate>
        <UDText variant="subtitle-1" color={theme.colors.WhiteGray}>
          {subtitle}
        </UDText>
      </S.InfoBlock>
    </S.MainBlock>
  );
}

export default UserInfo;
